module.exports = __webpack_public_path__ + "media/evolve/assets/icons/animated/cipher-logo-fd5f9083a2ae3cb5d1ba4c65a0d76378.svg";